const resources = {
  no: {
    translation: {
      "navbar.home": "Hjem",
      "navbar.contact": "Kontakt",
      "navbar.categories_button": "Kategorier",
      "navbar.categories.begravelse": "Begravelse",
      "navbar.categories.bestselger": "Bestselgere",
      "navbar.categories.bryllupsbuketter": "Bryllupsbuketter",
      "navbar.categories.bursdagsbuketter": "Bursdagsbuketter",
      "navbar.categories.dekorasjoner": "Dekorasjoner",
      "navbar.categories.rosebuketter": "Rosebuketter",
      "navbar.categories.julebuketter": "Julebuketter",

      "homepage.hero.title": "Aranka Orsos",
      "homepage.hero.subtitle": "EVIGHETSBLOMSTER",

      "homepage.tagline.title": "Skreddersydde blomsterarrangementer for alle anledninger",
      "homepage.tagline.body": "Skreddersydde blomsterarrangementer – silke, kunstige eller friske blomster. Unik design, håndlaget kvalitet – laget med omtanke.",

      "homepage.bullets.quality_silk_art": "Kvalitets silke- og kunstblomster",
      "homepage.bullets.fresh_on_request": "Ferske blomster på forespørsel",
      "homepage.bullets.unique_designs": "Unike design",
      "homepage.bullets.handcrafted": "Håndlaget kvalitet",
      "homepage.bullets.norwegian_suppliers": "Norske leverandører",
      "homepage.bullets.we_build_what_you_imagine": "Vi lager det du ser for deg",

      "filters.photos": "Bilder",
      "filters.orientation": "Orientering",
      "filters.landscape": "Liggende",
      "filters.portrait": "Stående",
      "filters.square": "Kvadrat",
      "filters.type": "Type",
      "filters.all": "Alle",

      "contact.title": "Kontakt oss",
      "contact.name": "Navn",
      "contact.email": "E‑post",
      "contact.message": "Melding",
      "contact.send": "Send",
      "contact.actions.email": "E‑post",
      "contact.actions.whatsapp": "WhatsApp",
      "contact.actions.call": "Ring",
      "contact.actions.facebook": "Facebook",
      "contact.placeholder.name": "Ditt navn",
      "contact.placeholder.email": "you@example.com",
      "contact.placeholder.message": "Skriv meldingen her…",
      "contact.email_subject": "Henvendelse",
      "contact.autofill": "Hei! Jeg vil gjerne spørre om dette elementet:\nKategori: {{cat}}\nRessurs: {{item}}\n",

      "hero.subtitle": "Skreddersydde blomsterarrangementer – silke, kunstige eller friske blomster. Unik design, håndlaget kvalitet – laget med omtanke.",
      "gallery": "Galleri",
      "contact.ask": "Spør om dette",

      "common.loading": "Laster…",
      "contact.lead": "Har du spørsmål eller spesialbestillinger? Send oss en melding."
}
  },
  en: {
    translation: {
      "navbar.home": "Home",
      "navbar.contact": "Contact",
      "navbar.categories_button": "Categories",
      "navbar.categories.begravelse": "Funeral",
      "navbar.categories.bestselger": "Bestsellers",
      "navbar.categories.bryllupsbuketter": "Wedding Bouquets",
      "navbar.categories.bursdagsbuketter": "Birthday Bouquets",
      "navbar.categories.dekorasjoner": "Decorations",
      "navbar.categories.rosebuketter": "Rose Bouquets",
      "navbar.categories.julebuketter": "Christmas Bouquets",

      "homepage.hero.title": "Aranka Orsos",
      "homepage.hero.subtitle": "EVERLASTING FLOWERS",

      "homepage.tagline.title": "Custom flower arrangements for every occasion",
      "homepage.tagline.body": "Custom arrangements — in silk, artificial or fresh flowers. Unique design, handcrafted quality — made with care.",

      "homepage.bullets.quality_silk_art": "Quality silk & artificial flowers",
      "homepage.bullets.fresh_on_request": "Fresh flowers on request",
      "homepage.bullets.unique_designs": "Unique designs",
      "homepage.bullets.handcrafted": "Handcrafted quality",
      "homepage.bullets.norwegian_suppliers": "Norwegian suppliers",
      "homepage.bullets.we_build_what_you_imagine": "We build what you imagine",

      "filters.photos": "Photos",
      "filters.orientation": "Orientation",
      "filters.landscape": "Landscape",
      "filters.portrait": "Portrait",
      "filters.square": "Square",
      "filters.type": "Type",
      "filters.all": "All",

      "contact.title": "Contact us",
      "contact.name": "Name",
      "contact.email": "Email",
      "contact.message": "Message",
      "contact.send": "Send",
      "contact.actions.email": "Email",
      "contact.actions.whatsapp": "WhatsApp",
      "contact.actions.call": "Call",
      "contact.actions.facebook": "Facebook",
      "contact.placeholder.name": "Your name",
      "contact.placeholder.email": "you@example.com",
      "contact.placeholder.message": "Write your message…",
      "contact.email_subject": "Inquiry",
      "contact.autofill": "Hi! I would like to ask about this item:\nCategory: {{cat}}\nItem: {{item}}\n",

      "hero.subtitle": "Custom arrangements — in silk, artificial or fresh flowers. Unique design, handcrafted quality — made with care.",
      "gallery": "Gallery",
      "contact.ask": "Ask about this",

      "common.loading": "Loading…",
      "contact.lead": "Have questions or special requests? Send us a message."
}
  },
  ru: {
    translation: {
      "navbar.home": "Главная",
      "navbar.contact": "Контакты",
      "navbar.categories.begravelse": "Траурные композиции",
      "navbar.categories.bestselger": "Популярное",
      "navbar.categories.bryllupsbuketter": "Свадебные букеты",
      "navbar.categories.bursdagsbuketter": "Букеты на день рождения",
      "navbar.categories.dekorasjoner": "Декорации",
      "navbar.categories.rosebuketter": "Букеты из роз",
      "navbar.categories.julebuketter": "Рождественские букеты",

      "homepage.hero.title": "Aranka Orsos",
      "homepage.hero.subtitle": "ВЕЧНЫЕ ЦВЕТЫ",

      "homepage.tagline.title": "Индивидуальные цветочные композиции для любого случая",
      "homepage.tagline.body": "Индивидуальные композиции — из шелковых, искусственных или свежих цветов. Уникальный дизайн, ручная работа — с заботой.",

      "homepage.bullets.quality_silk_art": "Качественные шелковые и искусственные цветы",
      "homepage.bullets.fresh_on_request": "Свежие цветы по запросу",
      "homepage.bullets.unique_designs": "Уникальные дизайны",
      "homepage.bullets.handcrafted": "Ручная работа",
      "homepage.bullets.norwegian_suppliers": "Норвежские поставщики",
      "homepage.bullets.we_build_what_you_imagine": "Сделаем то, что вы представляете",

      "filters.photos": "Фото",
      "filters.orientation": "Ориентация",
      "filters.landscape": "Альбомная",
      "filters.portrait": "Портретная",
      "filters.square": "Квадрат",
      "filters.type": "Тип",
      "filters.all": "Все",

      "contact.title": "Свяжитесь с нами",
      "contact.name": "Имя",
      "contact.email": "Эл. почта",
      "contact.message": "Сообщение",
      "contact.send": "Отправить",
      "contact.actions.email": "Почта",
      "contact.actions.whatsapp": "WhatsApp",
      "contact.actions.call": "Позвонить",
      "contact.actions.facebook": "Facebook",
      "contact.placeholder.name": "Ваше имя",
      "contact.placeholder.email": "you@example.com",
      "contact.placeholder.message": "Напишите сообщение…",
      "contact.email_subject": "Запрос",
      "contact.autofill": "Здравствуйте! Хочу уточнить по этому элементу:\nКатегория: {{cat}}\nПозиция: {{item}}\n",

      "hero.subtitle": "Индивидуальные композиции — из шелковых, искусственных или свежих цветов. Уникальный дизайн, ручная работа — с заботой.",
      "gallery": "Галерея",
      "contact.ask": "Спросить об этом",

      "common.loading": "Загрузка…",
      "contact.lead": "Есть вопросы или особые заказы? Напишите нам."
}
  },
  lt: {
    translation: {
      "navbar.home": "Pagrindinis",
      "navbar.contact": "Kontaktai",
      "navbar.categories_button": "Kategorijos",
      "navbar.categories.begravelse": "Laidojimo kompozicijos",
      "navbar.categories.bestselger": "Perkamiausi",
      "navbar.categories.bryllupsbuketter": "Vestuvinės puokštės",
      "navbar.categories.bursdagsbuketter": "Gimtadienio puokštės",
      "navbar.categories.dekorasjoner": "Dekoracijos",
      "navbar.categories.rosebuketter": "Rožių puokštės",
      "navbar.categories.julebuketter": "Kalėdinės puokštės",

      "homepage.hero.title": "Aranka Orsos",
      "homepage.hero.subtitle": "AMŽINOS GĖLĖS",

      "homepage.tagline.title": "Individualios gėlių kompozicijos kiekvienai progai",
      "homepage.tagline.body": "Individualios kompozicijos — iš šilko, dirbtinių arba šviežių gėlių. Unikalus dizainas, rankų darbo kokybė — su rūpesčiu.",

      "homepage.bullets.quality_silk_art": "Kokybiškos šilko ir dirbtinės gėlės",
      "homepage.bullets.fresh_on_request": "Šviežios gėlės pagal užsakymą",
      "homepage.bullets.unique_designs": "Unikalūs dizainai",
      "homepage.bullets.handcrafted": "Rankų darbo kokybė",
      "homepage.bullets.norwegian_suppliers": "Norvegų tiekėjai",
      "homepage.bullets.we_build_what_you_imagine": "Sukuriame tai, ką įsivaizduojate",

      "filters.photos": "Nuotraukos",
      "filters.orientation": "Orientacija",
      "filters.landscape": "Gulsčias",
      "filters.portrait": "Stačias",
      "filters.square": "Kvadratas",
      "filters.type": "Tipas",
      "filters.all": "Visi",

      "contact.title": "Susisiekite su mumis",
      "contact.name": "Vardas",
      "contact.email": "El. paštas",
      "contact.message": "Žinutė",
      "contact.send": "Siųsti",
      "contact.actions.email": "El. paštas",
      "contact.actions.whatsapp": "WhatsApp",
      "contact.actions.call": "Skambinti",
      "contact.actions.facebook": "Facebook",
      "contact.placeholder.name": "Jūsų vardas",
      "contact.placeholder.email": "you@example.com",
      "contact.placeholder.message": "Parašykite žinutę…",
      "contact.email_subject": "Užklausa",
      "contact.autofill": "Sveiki! Norėčiau pasiteirauti dėl šio elemento:\nKategorija: {{cat}}\nPozicija: {{item}}\n",

      "hero.subtitle": "Individualios kompozicijos — iš šilko, dirbtinių arba šviežių gėlių. Unikalus dizainas, rankų darbo kokybė — su rūpesčiu.",
      "gallery": "Galerija",
      "contact.ask": "Paklausti apie šį",

      "common.loading": "Įkeliama…",
      "contact.lead": "Turite klausimų ar specialių užsakymų? Parašykite mums."
}
  },
  sk: {
    translation: {
      "navbar.home": "Domov",
      "navbar.contact": "Kontakt",
      "navbar.categories_button": "Kategórie",
      "navbar.categories.begravelse": "Smútočné aranžmány",
      "navbar.categories.bestselger": "Najpredávanejšie",
      "navbar.categories.bryllupsbuketter": "Svadobné kytice",
      "navbar.categories.bursdagsbuketter": "Narodeninové kytice",
      "navbar.categories.dekorasjoner": "Dekorácie",
      "navbar.categories.rosebuketter": "Kytice z ruží",

      "homepage.hero.title": "Aranka Orsos",
      "homepage.hero.subtitle": "VEČNÉ KVETY",

      "homepage.tagline.title": "Na mieru robené kvetinové aranžmány na každú príležitosť",
      "homepage.tagline.body": "Na mieru robené aranžmány — z hodvábnych, umelých alebo čerstvých kvetov. Jedinečný dizajn, ručná kvalita — s ohľadom a starostlivosťou.",

      "homepage.bullets.quality_silk_art": "Kvalitné hodvábne a umelé kvety",
      "homepage.bullets.fresh_on_request": "Čerstvé kvety na požiadanie",
      "homepage.bullets.unique_designs": "Jedinečné dizajny",
      "homepage.bullets.handcrafted": "Ručne vyrábaná kvalita",
      "homepage.bullets.norwegian_suppliers": "Nórski dodávatelia",
      "homepage.bullets.we_build_what_you_imagine": "Vytvoríme to, čo si predstavíte",

      "filters.photos": "Fotografie",
      "filters.orientation": "Orientácia",
      "filters.landscape": "Na šírku",
      "filters.portrait": "Na výšku",
      "filters.square": "Štvorec",
      "filters.type": "Typ",
      "filters.all": "Všetko",

      "contact.title": "Kontaktujte nás",
      "contact.name": "Meno",
      "contact.email": "E‑mail",
      "contact.message": "Správa",
      "contact.send": "Odoslať",
      "contact.actions.email": "E‑mail",
      "contact.actions.whatsapp": "WhatsApp",
      "contact.actions.call": "Zavolať",
      "contact.actions.facebook": "Facebook",
      "contact.placeholder.name": "Vaše meno",
      "contact.placeholder.email": "you@example.com",
      "contact.placeholder.message": "Napíšte správu…",
      "contact.email_subject": "Dopyt",
      "contact.autofill": "Dobrý deň! Rád by som sa opýtal na túto položku:\nKategória: {{cat}}\nPoložka: {{item}}\n",

      "hero.subtitle": "Na mieru robené aranžmány — z hodvábnych, umelých alebo čerstvých kvetov. Jedinečný dizajn, ručná kvalita — s ohľadom a starostlivosťou.",
      "gallery": "Galéria",
      "contact.ask": "Opýtať sa na toto",

      "common.loading": "Načítava sa…",
      "contact.lead": "Máte otázky alebo špeciálne požiadavky? Pošlite nám správu."
}
  },
  hu: {
    translation: {
      "navbar.home": "Főoldal",
      "navbar.contact": "Kapcsolat",
      "navbar.categories_button": "Kategóriák",
      "navbar.categories.begravelse": "Gyászkompozíciók",
      "navbar.categories.bestselger": "Legnépszerűbbek",
      "navbar.categories.bryllupsbuketter": "Menyasszonyi csokrok",
      "navbar.categories.bursdagsbuketter": "Születésnapi csokrok",
      "navbar.categories.dekorasjoner": "Dekorációk",
      "navbar.categories.rosebuketter": "Rózsacsokrok",
      "navbar.categories.julebuketter": "Karácsonyi csokrok",

      "homepage.hero.title": "Aranka Orsos",
      "homepage.hero.subtitle": "ÖRÖK VIRÁGOK",

      "homepage.tagline.title": "Egyedi virágkompozíciók minden alkalomra",
      "homepage.tagline.body": "Egyedi kompozíciók — selyem-, mű- vagy friss virágokból. Egyedi dizájn, kézzel készült minőség — gondossággal.",

      "homepage.bullets.quality_silk_art": "Minőségi selyem és művirágok",
      "homepage.bullets.fresh_on_request": "Friss virág kérésre",
      "homepage.bullets.unique_designs": "Egyedi dizájnok",
      "homepage.bullets.handcrafted": "Kézzel készült minőség",
      "homepage.bullets.norwegian_suppliers": "Norvég beszállítók",
      "homepage.bullets.we_build_what_you_imagine": "Megvalósítjuk, amit elképzelsz",

      "filters.photos": "Fotók",
      "filters.orientation": "Tájolás",
      "filters.landscape": "Fekvő",
      "filters.portrait": "Álló",
      "filters.square": "Négyzet",
      "filters.type": "Típus",
      "filters.all": "Összes",

      "contact.title": "Lépjen kapcsolatba velünk",
      "contact.name": "Név",
      "contact.email": "E‑mail",
      "contact.message": "Üzenet",
      "contact.send": "Küldés",
      "contact.actions.email": "E‑mail",
      "contact.actions.whatsapp": "WhatsApp",
      "contact.actions.call": "Hívás",
      "contact.actions.facebook": "Facebook",
      "contact.placeholder.name": "Neved",
      "contact.placeholder.email": "you@example.com",
      "contact.placeholder.message": "Írd meg az üzeneted…",
      "contact.email_subject": "Érdeklődés",
      "contact.autofill": "Szia! Érdeklődnék erről a tételről:\nKategória: {{cat}}\nTétel: {{item}}\n",

      "hero.subtitle": "Egyedi kompozíciók — selyem-, mű- vagy friss virágokból. Egyedi dizájn, kézzel készült minőség — gondossággal.",
      "gallery": "Galéria",
      "contact.ask": "Kérdés erről",

      "common.loading": "Betöltés…",
      "contact.lead": "Kérdése van vagy egyedi igénye? Írjon nekünk."
}
  },
  uk: {
    translation: {
      "navbar.home": "Головна",
      "navbar.contact": "Контакти",
      "navbar.categories_button": "Категорії",
      "navbar.categories.begravelse": "Траурні композиції",
      "navbar.categories.bestselger": "Хіти продажу",
      "navbar.categories.bryllupsbuketter": "Весільні букети",
      "navbar.categories.bursdagsbuketter": "Букети на день народження",
      "navbar.categories.dekorasjoner": "Декорації",
      "navbar.categories.rosebuketter": "Букети з троянд",
      "navbar.categories.julebuketter": "Різдвяні букети",

      "homepage.hero.title": "Aranka Orsos",
      "homepage.hero.subtitle": "ВІЧНІ КВІТИ",

      "homepage.tagline.title": "Індивідуальні квіткові композиції для будь-якої події",
      "homepage.tagline.body": "Індивідуальні композиції — з шовкових, штучних або свіжих квітів. Унікальний дизайн, ручна якість — створено з турботою.",

      "homepage.bullets.quality_silk_art": "Якісні шовкові та штучні квіти",
      "homepage.bullets.fresh_on_request": "Свіжі квіти на запит",
      "homepage.bullets.unique_designs": "Унікальні дизайни",
      "homepage.bullets.handcrafted": "Ручна робота",
      "homepage.bullets.norwegian_suppliers": "Норвезькі постачальники",
      "homepage.bullets.we_build_what_you_imagine": "Створимо те, що ви уявляєте",

      "filters.photos": "Фото",
      "filters.orientation": "Орієнтація",
      "filters.landscape": "Альбомна",
      "filters.portrait": "Портретна",
      "filters.square": "Квадрат",
      "filters.type": "Тип",
      "filters.all": "Усі",

      "contact.title": "Зв’яжіться з нами",
      "contact.name": "Ім’я",
      "contact.email": "Ел. пошта",
      "contact.message": "Повідомлення",
      "contact.send": "Надіслати",
      "contact.actions.email": "Пошта",
      "contact.actions.whatsapp": "WhatsApp",
      "contact.actions.call": "Подзвонити",
      "contact.actions.facebook": "Facebook",
      "contact.placeholder.name": "Ваше ім’я",
      "contact.placeholder.email": "you@example.com",
      "contact.placeholder.message": "Напишіть повідомлення…",
      "contact.email_subject": "Запит",
      "contact.autofill": "Вітаю! Хочу уточнити щодо цього елемента:\nКатегорія: {{cat}}\nПозиція: {{item}}\n",

      "hero.subtitle": "Індивідуальні композиції — з шовкових, штучних або свіжих квітів. Унікальний дизайн, ручна якість — створено з турботою.",
      "gallery": "Галерея",
      "contact.ask": "Запитати про це",

      "common.loading": "Завантаження…",
      "contact.lead": "Є запитання чи особливе замовлення? Напишіть нам."
}
  }
};
export default resources;
